// src/hocs/withT.js
import { withTranslation } from 'react-i18next';

const withT = (Component) => withTranslation()(Component);

export default withT;
